import React, { useState, useEffect, useContext } from "react";
import { Auth } from "../../Contexts/AuthContext";

const Wallet = () => {
  const [balance, setBalance] = useState(2845.6);
  const [transactions, setTransactions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const { auth } = useContext(Auth);
  const sampleTransactions = [
    {
      id: 1,
      name: "Netflix Subscription",
      type: "debit",
      amount: 15.99,
      date: "2024-01-15",
      icon: "fas fa-film",
    },
    {
      id: 2,
      name: "Freelance Payment",
      type: "credit",
      amount: 1200.0,
      date: "2024-01-14",
      icon: "fas fa-laptop-code",
    },
    {
      id: 3,
      name: "Amazon Purchase",
      type: "debit",
      amount: 89.5,
      date: "2024-01-12",
      icon: "fas fa-shopping-cart",
    },
    {
      id: 4,
      name: "Salary Deposit",
      type: "credit",
      amount: 3200.0,
      date: "2024-01-10",
      icon: "fas fa-money-check-alt",
    },
    {
      id: 5,
      name: "Uber Ride",
      type: "debit",
      amount: 24.75,
      date: "2024-01-09",
      icon: "fas fa-car",
    },
    {
      id: 6,
      name: "Stock Dividend",
      type: "credit",
      amount: 145.25,
      date: "2024-01-08",
      icon: "fas fa-chart-line",
    },
    {
      id: 7,
      name: "Grocery Store",
      type: "debit",
      amount: 85.3,
      date: "2024-01-07",
      icon: "fas fa-shopping-basket",
    },
    {
      id: 8,
      name: "Online Course",
      type: "debit",
      amount: 49.99,
      date: "2024-01-05",
      icon: "fas fa-graduation-cap",
    },
  ];
  console.log("auth at wallet", auth?.user);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(amount);
  };

  // Format date
  const formatDate = (dateString) => {
    const options = { month: "short", day: "numeric", year: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };

  const refreshBalance = () => {
    setRefreshing(true);

    // Simulate API call
    setTimeout(() => {
      // Add a small random change to balance for demo
      const change = Math.random() * 100 - 50;
      const newBalance = Math.max(0, balance + change);
      setBalance(parseFloat(newBalance.toFixed(2)));
      setRefreshing(false);
    }, 1000);
  };

  const calculateStats = () => {
    const income = transactions
      .filter((t) => t.type === "credit")
      .reduce((sum, t) => sum + t.amount, 0);

    const expenses = transactions
      .filter((t) => t.type === "debit")
      .reduce((sum, t) => sum + t.amount, 0);

    return { income, expenses };
  };

  useEffect(() => {
    // Simulate loading data
    setTimeout(() => {
      setTransactions(sampleTransactions);
      setIsLoading(false);
    }, 1500);
  }, []);

  const stats = calculateStats();

  return (
    <div className="wallet-container">
      <header className="wallet-header">
        <div className="logo">
          <i className="fas fa-wallet wallet-icon"></i>
          <h1>My Wallet Dashboard</h1>
        </div>
        <div className="user-info">
          <div className="avatar">
            <i className="fas fa-user"></i>
            <img alt="fileInfsso" src={auth?.user?.avatar} />
          </div>
          <span className="user-name">
            {auth?.user?.first_name} {auth?.user?.last_name}
          </span>
        </div>
      </header>

      <section className="balance-section">
        <div className="balance-card">
          <div className="balance-header">
            <h2>
              <i className="fas fa-coins"></i>
              Current Balance
            </h2>
            <button
              className={`refresh-btn ${refreshing ? "refreshing" : ""}`}
              onClick={refreshBalance}
              disabled={refreshing}
            >
              <i
                className={`fas fa-sync-alt ${refreshing ? "fa-spin" : ""}`}
              ></i>
              {refreshing ? "Refreshing..." : "Refresh Balance"}
            </button>
          </div>
          <div className="balance-amount">
            <span className="currency">$</span>
            <span className="amount">
              {/* {balance.toLocaleString("en-US", { minimumFractionDigits: 2 })} */}
              {auth?.user?.wallet_balance}
            </span>
          </div>
          <div className="balance-stats">
            <div className="stat">
              <span className="stat-label">Total Income</span>
              <span className="stat-value positive">
                +{formatCurrency(stats.income)}
              </span>
            </div>
            <div className="stat">
              <span className="stat-label">Total Expenses</span>
              <span className="stat-value negative">
                -{formatCurrency(stats.expenses)}
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="transactions-section">
        <div className="section-header">
          <h2>
            <i className="fas fa-exchange-alt"></i>
            Recent Transactions
          </h2>
          <a href="#" className="view-all">
            View All <i className="fas fa-arrow-right"></i>
          </a>
        </div>

        {isLoading ? (
          <div className="loading">
            <div className="spinner"></div>
            <p>Loading transactions...</p>
          </div>
        ) : transactions.length === 0 ? (
          <div className="empty-state">
            <i className="fas fa-receipt"></i>
            <p>No transactions yet</p>
          </div>
        ) : (
          <div className="transactions-list">
            {transactions.map((transaction) => (
              <div
                key={transaction.id}
                className={`transaction-item ${transaction.type}`}
              >
                <div className={`transaction-icon ${transaction.type}`}>
                  <i className={transaction.icon}></i>
                </div>
                <div className="transaction-details">
                  <div className="transaction-name">{transaction.name}</div>
                  <div className="transaction-date">
                    {formatDate(transaction.date)}
                  </div>
                </div>
                <div className={`transaction-amount ${transaction.type}`}>
                  {transaction.type === "credit" ? "+" : "-"}
                  {formatCurrency(transaction.amount)}
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default Wallet;
